<template>
  <v-navigation-drawer
    v-model="storeResource.status"
    width="350"
    fixed
    temporary
    right
  >
    <component :is="storeResource.componentName"></component>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SidebarRightComponent",

  computed: {
    ...mapGetters({
      storeResource: "getSidebarRigthData",
    }),
  },

  components: {
    //
  },
};
</script>
